import 'css-chunk:src/components/button-toggle/button-toggle-component.module.scss';export default {
  "container": "button-toggle-component_container__gEHr9",
  "button": "button-toggle-component_button__ohVEg"
};